import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { Directory } from '../models/hub';

@Injectable( {
  providedIn: 'root'
} )
export class ManageHub
{

  constructor(
    private _http: HttpClient
  ) { }

  private API_BASE = environment.apiBaseUrl;
  private API_CONFIG = environment.apiEndpoints.configuration;

  public async getDocumentsTree( hubId: string ): Promise<Directory>
  {
    const url = `${this.API_BASE}${this.API_CONFIG.hub.documentsTree}/${hubId}`;
    const response = await this._http.get<Directory>( url ).toPromise();
    return ( response ) as Directory;
  }


}
